import React, { useEffect, useState } from "react";
import Select from "react-select";

function Dropdowncoordinator({
  name,
  register,
  labelTitle,
  placeholder,
  icon,
  setValue,
  showError,
  errorMessage,
  options,
  showMandatory = false,
  defaultOption,
  parentProps,
  onChange,
  resetValue,
  setResetValue,
  setCustomValue,
  customValue,
  additionalclass,
  labelclass,
  ...props
}) {
  const [selectedOption, setSelectedOption] = useState(defaultOption);

  useEffect(() => {
    if (resetValue) {
      setResetValue(false);
      setSelectedOption(null);
    }
  }, [resetValue]);

  useEffect(() => {
    if (customValue) {
      setCustomValue(null);
      setSelectedOption(customValue);
      if (setValue) setValue(name, customValue.value, { shouldValidate: true });
    }
  }, [customValue]);

  return (
    <div className="form-group coform-control d-flex flex-column w-100 mb-3" {...parentProps}>
      <h3 className={`fw-600 medium-text mb-0 ${labelclass}`}>
        {labelTitle}{showMandatory ? <span className="danger">*</span> : null}
      </h3>

      <div className={`d-flex flex-column reward-dropdown-mobile  ${additionalclass}`}>
        <div className="d-flex gap-2 ">
          <Select
            className="rewarddropdowntext w-100 border-0"
            defaultValue={selectedOption}
            maxMenuHeight={200}
            onChange={(e) => {
              if (setValue) setValue(name, e.value, { shouldValidate: true });
            
              if (onChange) onChange(e);
              setSelectedOption(e);
            }}
            value={selectedOption}
            {...props}

            placeholder={placeholder}
            noOptionsMessage={() => "No Data Available!"}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: 0,
                boxShadow: "none",
                borderColor: '#e2e2e2',
                background: "transparent"
              }),
              container: (baseStyles, state) => ({
                ...baseStyles
              }),
              valueContainer: (baseStyles, state) => ({
                ...baseStyles,
                padding: '6px 16px',
                fontSize: "14px",
                fontWeight: "400",

              }),
            //   singleValue: (baseStyles, state) => ({
            //     ...baseStyles,
            //     color: selectedOption ? '#F6821F' : 'black',
            //     fontWeight: 600,
            //     fontSize: 16,
            //   }),
              indicatorSeparator: (baseStyles, state) => ({
                ...baseStyles,
                display: "none"

              }),
            //   dropdownIndicator: (baseStyles, state) => ({
            //     ...baseStyles,
            //     color: selectedOption ? '#F6821F' : 'black',
            //   }),
              menu: (baseStyles, state) => ({
                ...baseStyles,
                zIndex: 999,
                clipPath: "padding-box",
                borderRadius: 6,
                boxShadow: "0px 0px 10px #0000001A",
                border: 0
              }),
              menuList: (baseStyles, state) => ({
                ...baseStyles,
                padding: 0,
                border: "0"

              }),
              option: (baseStyles, state) => ({
                ...baseStyles,
                padding: "12px 16px",
                fontWeight: 600,
                fontSize: 16,
                borderBottom: "0",

              }),
            }}
            theme={(theme) => ({
              ...theme,
              borderRadius: 8,
              colors: {
                ...theme.colors,
                primary25: "#e2e2e2",
                primary: "#14489F",
                neutral90: "#FFFFFF",
              },
            })}
            options={options}
          />
        </div>
      </div>

      {showError ? <span className="danger fs-14 fw-400 mt-1">{errorMessage}</span> : null}
    </div>
  );
}

export default Dropdowncoordinator;
